import { X } from 'lucide-react';

import { DrawerProps } from './types';

import { Button } from 'components/ui/button';

export const Drawer = ({ open, children, onClose, title }: DrawerProps) => {
  return (
    <>
      <div
        className={`fixed inset-y-0 right-0 max-w-80 bg-white transform transition-transform duration-300 ease-in-out z-50 overflow-y-auto ${
          open ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="sticky top-0 bg-white z-10 p-4 border-b flex items-center justify-between">
          <h2 className="font-semibold text-lg">{title}</h2>
          <Button variant="ghost" size="icon" onClick={() => onClose(false)}>
            <X className="h-4 w-4" />
          </Button>
        </div>

        <div className="p-4 space-y-6">{children}</div>
      </div>
      {open && <div className="fixed inset-0 bg-black/20 z-40" onClick={() => onClose(false)} />}
    </>
  );
};
